import { Autocomplete, debounce, TextField } from "@mui/material";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { ONE_MAP_URL } from "../utils/OneMapURL";

interface AutoCompleteAddressProps {
  input: string;
  setInput: (x: string) => void;
  id: string;
  name: string;
  error: any;
  helperText: any;
  placeholder: string;
  addressOptions: any[];
  setAddressOptions: (x: any) => void;
}

const AutoCompleteAddress = (props: AutoCompleteAddressProps) => {
  const {
    id,
    name,
    setInput,
    input,
    error,
    helperText,
    placeholder,
    setAddressOptions,
    addressOptions,
    ...rest
  } = props;

  /* A function that is called when the input is changed. */
  const callAddressApi = useCallback(
    debounce((searchVal: string) => {
      axios
        .request({
          method: "GET",
          url: `${ONE_MAP_URL}`,
          params: {
            searchVal,
            getAddrDetails: "Y",
            returnGeom: "N",
            pageNum: 1,
          },
        })
        .then((res) => {
          if (res.data.found >= 1) {
            localStorage.setItem("data", "founded");
            // Set postal code
            setAddressOptions(
              res.data.results
                .filter(
                  (item: any) => !item.ADDRESS.includes("JOHOR (MALAYSIA)")
                )
                .map(
                  (item: any) =>
                    `${item.BLK_NO !== "NIL" ? item.BLK_NO : ""} ${
                      item.ROAD_NAME !== "NIL" ? item.ROAD_NAME : ""
                    } ${item.BUILDING !== "NIL" ? item.BUILDING : ""} ${
                      item.POSTAL !== "NIL" ? item.POSTAL : ""
                    }`
                )
            );
          } else {
            localStorage.setItem("data", "notfounded");
            setAddressOptions([]);
          }
        })
        .catch((e) => {
          setAddressOptions([]);
        });
    }, 1000),
    []
  );

  useEffect(() => {
    if (input !== "") {
      callAddressApi(input);
    }
  }, [input]);

  return (
    <Autocomplete
      id={id}
      options={addressOptions}
      freeSolo
      disableClearable
      value={input ?? ""}
      onChange={(event, value) => {
        setInput(value);
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            id={id}
            name={name}
            value={input}
            error={error}
            placeholder={placeholder}
            style={{ maxHeight: "40px" }}
            size="small"
            InputProps={{ ...params.InputProps, type: "search" }}
            onChange={(event) => {
              setInput(event.target.value);
            }}
            helperText={helperText}
          />
        );
      }}
    />
  );
};

export default AutoCompleteAddress;
